// @flow
import {
  UPDATE_NEWSLETTER_NOTIFICATION,
  UPDATE_NEWSLETTER_NOTIFICATION_ERROR,
  SET_NEWSLETTER_NOTIFICATIONS,
  RESTORE_NEWSLETTER_NOTIFICATIONS,
  DISABLE_NEWSLETTER_NOTIFICATION_FROM_EMAIL,
} from './actionTypes';
import type { NewsletterNotificationUpdate } from './types';
import type { NewsletterNotifications } from '../types';

export function setNewsletterNotifications(notifications: NewsletterNotifications): TrovitAction {
  return {
    type: SET_NEWSLETTER_NOTIFICATIONS,
    payload: notifications,
  };
}

export function updateNewsletterNotification(update: NewsletterNotificationUpdate): TrovitAction {
  return {
    type: UPDATE_NEWSLETTER_NOTIFICATION,
    payload: update,
  };
}

export function updateNewsletterNotificationError(
  rollbackUpdate: NewsletterNotificationUpdate
): TrovitAction {
  return {
    type: UPDATE_NEWSLETTER_NOTIFICATION_ERROR,
    payload: rollbackUpdate,
  };
}

export function restoreNewsletterNotifications(
  notifications: NewsletterNotifications
): TrovitAction {
  return {
    type: RESTORE_NEWSLETTER_NOTIFICATIONS,
    payload: notifications,
  };
}

export function disableNewsletterNotificationFromEmail(newsletterType: String): TrovitAction {
  return {
    type: DISABLE_NEWSLETTER_NOTIFICATION_FROM_EMAIL,
    payload: newsletterType,
  };
}



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/NewsletterNotifications/actions.js